import React from "react";
import { ShieldCheck } from "lucide-react";

/** Small "verified" tick shown next to user names on profile cards,
 *  match list, comments, etc. Reads `user.verified` from the public payload. */
export default function VerifiedBadge({ user, className = "", size = 12 }) {
  if (!user?.verified) return null;
  return (
    <span
      data-testid="verified-badge"
      title="Verified"
      className={`inline-flex items-center justify-center rounded-full bg-[#8FE0C5] text-[#16171A] ${className}`}
      style={{ width: size + 4, height: size + 4 }}
    >
      <ShieldCheck style={{ width: size, height: size }} strokeWidth={3} />
    </span>
  );
}
